import styled from '@emotion/styled';

export const ScrollArrowButton = styled.button`
  position: absolute;
  top: -5px;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0px 0px 0px 20px;
  background: transparent;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 1)
  );
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.3s ease;
  border: none;
  z-index: 100;

  &.left {
    left: 0;
    padding-left: 0px;
    padding-right: 20px;
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.8),
      rgba(255, 255, 255, 1)
    );
  }

  &.right {
    right: 0;
  }

  &.visible {
    opacity: 1;
  }
`;
